<div class="trustee-contact-type-multi-select">
  <p-multiSelect
    [options]="allItems"
    [ngModel]="selectedValue"
    (ngModelChange)="onChange($event)"
    [readonly]="disabled"
    [styleClass]="hasError ? 'p-state-error' : ''"
    appendTo="body"
    placeholder="Touts types"
  >
    <ng-template let-selectedItems pTemplate="selectedItems">
      <div *ngIf="selectedItems?.length < allItems.length && selectedItems?.length > 0; else anyItem">
        <span *ngFor="let item of selectedItems" class="enum-item">
          <app-trustee-contact-type [contactType]="item"></app-trustee-contact-type>
        </span>
      </div>
      <ng-template #anyItem>
        <span i18n>Tous types</span>
      </ng-template>
    </ng-template>
  </p-multiSelect>
</div>
